import numeral from 'numeral'

// Helper function to format currency with proper symbol
function formatCurrency(amount, currency) {
  const formatted = numeral(amount).format('0,0')

  const currencyFormats = {
    USD: `$${formatted}`,
    EUR: `€${formatted}`,
    GBP: `£${formatted}`,
    CAD: `CA$${formatted}`,
    AUD: `A$${formatted}`,
  }

  return currencyFormats[currency] || `${currency} ${formatted}`
}

// Conversion function
function convertPrice(price, fromCurrency, toCurrency) {
  const conversionRates = {
    USD_EUR: 0.93,
    EUR_USD: 1.08,
    GBP_USD: 1.25,
    USD_GBP: 0.8,
    EUR_GBP: 0.85,
    GBP_EUR: 1.17,
    CAD_USD: 0.74,
    USD_CAD: 1.35,
    AUD_USD: 0.66,
    USD_AUD: 1.52,
  }

  if (fromCurrency === toCurrency) return price

  const conversionKey = `${fromCurrency}_${toCurrency}`
  const rate = conversionRates[conversionKey] || 1

  return Math.round(price * rate)
}

// Display currency: USD shows single, others show dual with USD conversion
export function castCurrency(num, baseCurrency = 'USD') {
  const baseFormatted = formatCurrency(num, baseCurrency)

  // If USD, show only USD (no dual pricing)
  if (baseCurrency === 'USD') {
    return baseFormatted
  }

  // For all other currencies, show dual pricing with USD conversion
  const usdPrice = convertPrice(num, baseCurrency, 'USD')
  const usdFormatted = formatCurrency(usdPrice, 'USD')

  return `${baseFormatted} / ${usdFormatted}`
}
